<template>
	<div :class="componentClass" class="filters">
		<div>
			<component
				:is="component(filter.type)" v-for="(filter, filterIndex) in Object.values(filters)" :key="filterIndex"
				:filter="applyFilter"
				:filter-data="filter"/>
		</div>
		<button v-if="showDownload" class="button--icon icon--pdf" @click.prevent="download()">Download</button>
	</div>
</template>
<script>
import FilterCheckboxes from "@/common/components/v-table/filters/FilterCheckboxes.vue";
import FilterDate from "@/common/components/v-table/filters/FilterDate.vue";
import FilterMeta from "@/common/components/v-table/filters/FilterMeta.vue";
import FilterSearch from "@/common/components/v-table/filters/FilterSearch.vue";
import FilterSince from "@/common/components/v-table/filters/FilterSince.vue";
import FormFieldSearch from "@/components/forms/fields/FormFieldSearch.vue";
import opensFile from "@/mixins/opensFile";

export default {
	components: {
		FormFieldSearch,
		FilterCheckboxes,
		FilterDate,
		FilterMeta,
		FilterSearch,
		FilterSince,
	},

	mixins: [
		opensFile,
	],

	computed: {
		componentClass() {
			return {
				"filters--empty": !Object.keys(this.filters).length,
			};
		},
	},

	props: {
		filters: {
			required: false,
			type: [Array, Object],
			default() {
				return [];
			},
		},
		showDownload: {
			required: false,
			type: Boolean,
			default() {
				return false;
			},
		},
	},

	methods: {
		component(type) {
			return this.stringer("filter_" + type).camel().value;
		},
		applyFilter(key, value) {
			let query = this.$parent.store.query;
			_.set(query, "filter." + key, value);
			this.$parent.filter(query);
		},
		clearFilter(key) {
			this.$parent.clearFilter("filter." + key);
		},
		download() {
			let query = {
				filter: Object.assign({}, this.$parent.store.query.filter),
			};


			let filename = this.stringer(this.$parent.store.routes.index.split("/").pop()).ucWords().join("").value;
			let uri = this.route(this.$parent.store.routes.index + "/download", [], query);

			this.streamFile(
				uri,
				filename + ".csv",
				uri,
			);
		},
	},
};
</script>
